import StandardResponse from '../../models/standard-response';
import BaseService from '../base-service';
import type {
    ISearchChargeStationParams,
    IStation,
    IStationDetailsModel,
    ITariffAvailable,
    ITariffBreakDown,
    IValidateCardRequest,
    IValidateCardResponse,
} from '../../models/search-page';

export const getCodesList = async (data: ISearchChargeStationParams): Promise<StandardResponse<IStation[]>> => {
    try {
        const res = await BaseService({
            url: `web-pay/charge-locations/stations/search`,
            method: 'POST',
            data: { ...data, hideSpinner: true },
        });
        return new StandardResponse<IStation[]>(res.status, res.data.data, res.data.message, '');
    } catch (e) {
        return Promise.reject(e);
    }
};

export const getStationDetailsByCode = async (unique_code: string): Promise<StandardResponse<IStationDetailsModel>> => {
    try {
        const res = await BaseService({
            url: `web-pay/charge-locations/stations/${unique_code}`,
            method: 'GET',
            data: { hideSpinner: false },
        });

        return new StandardResponse<IStationDetailsModel>(res.status, res.data.data, res.data.message, '');
    } catch (e) {
        return Promise.reject(e);
    }
};

export const validateCard = async (data: IValidateCardRequest): Promise<StandardResponse<IValidateCardResponse>> => {
    try {
        const res = await BaseService({
            url: `web-pay/charge-sessions/continue-session`,
            method: 'POST',
            data,
        });

        return new StandardResponse<IValidateCardResponse>(res.status, res.data.data, res.data.message, '');
    } catch (e) {
        return Promise.reject(e);
    }
};

export const checkIsTariffApplied = async (connector_id: number): Promise<StandardResponse<ITariffAvailable>> => {
    try {
        const res = await BaseService({
            url: `web-pay/connector/${connector_id}/tariff-availability`,
            method: 'GET',
        });

        return new StandardResponse<ITariffAvailable>(res.status, res.data.data, res.data.message, '');
    } catch (e) {
        return Promise.reject(e);
    }
};

export const getTariffBreakDownDetails = async (connectorId: number): Promise<StandardResponse<ITariffBreakDown>> => {
    try {
        const res = await BaseService({
            url: `web-pay/connector/${connectorId}/tariff-breakdown`,
            method: 'GET',
        });

        return new StandardResponse<ITariffBreakDown>(res.status, res.data.data, res.data.message, '');
    } catch (e) {
        return Promise.reject(e);
    }
};
